import SettingsIcon from '@mui/icons-material/People';
import ForceUpdateButton from './ForceUpdateButton';
import RestoreMessages from './RestoreMessages';

export default {
  list: <RestoreMessages />,
  icon: SettingsIcon,
  options: {
    label: 'Utilitaires',
  },
};
